import { TRIGGER_FETCH_BILL_DETAILS_API, TRIGGER_FETCH_BILL_DETAILS_API_SUCCESS } from 'redux/actionTypes';

export function triggerFetchBillDetailsApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_FETCH_BILL_DETAILS_API,
		data,
		stopLoader,
		callback,
	};
}

export function triggerFetchBillDetailsApiCallSuccess(data) {
	return {
		type: TRIGGER_FETCH_BILL_DETAILS_API_SUCCESS,
		data,
	};
}
